export const ROUTES = {
    ROOT: '/',
    LOGIN: '/login',
    SIGN_UP: '/sign-up',
    FORGOT_PASSWORD: '/forgot-password',
    RESET_PASSWORD: '/reset-password',
    PUBLIC_REQUEST: '/public',
    FAMILY_ASSISTANCE_ENTRY: '/family-assistance',
    RESPONDER_REGISTRATION: '/responder',
    USER_SETTINGS: '/user-settings',
    VIEWER_MAP: '/viewer-map',
    CREATE_ORGANIZATION: '/create-organization',
    EDIT_ORGANIZATION: '/edit-organization',
    // Admin routes
    ADMIN: {
        ROOT: '/admin',
        TENANTS: '/admin/tenants',
        USERS: '/admin/users',
    },
    // VAdmin routes
    VADMIN: {
        ROOT: '/vadmin',
        GENERAL_CONTACTS: '/vadmin/general-contacts',
        EDIT_CONTACTS: '/vadmin/general-contacts/edit-contact',
        MATCH_VICTIMS: '/vadmin/match-victims',
        NOTIFY_VICTIMS: '/vadmin/notify-victims',
        FAMILY_ASSISTANCE: '/vadmin/family-assistance',
        FAMILY_ASSISTANCE_ENTRIES: '/vadmin/family-assistance/entries',
        //ADD_FAMILY_ASSISTANCE: '/vadmin/family-assistance/add',
        EDIT_FAMILY_ASSISTANCE: '/vadmin/family-assistance/edit/:id',
        VICTIM_REUNIFICATION: '/vadmin/victim-reunification',
        MAP_VICTIMS: '/vadmin/map-victims',
        STATUS_REVIEW: '/vadmin/status-review/:incidentId',
        AFTER_ACTION_REPORT: '/vadmin/after-action-report',
    },
    // VTracker routes
    VTRACKER: {
        ROOT: '/vtracker',
        ADD_VICTIM: '/vtracker/add-victim',
        EDIT_VICTIM: '/vtracker/edit-victim',
        ALL_VICTIMS: '/vtracker/all-victims',
        ALL_CONTACTS: '/vtracker/all-contacts',
        ADD_CONTACT: '/vtracker/all-contacts/add-contact',
        EDIT_CONTACT: '/vtracker/all-contacts/edit-contact',
        HOT_WASH: '/vtracker/hot-wash'
    },
    // Organization Settings routes
    ORGANIZATION_SETTINGS:{
        ROOT: '/organization-settings',
        USERS_ADMINISTRATION: '/organization-settings/users-administration',
        ADD_USER: '/organization-settings/users-administration/add-user',
        LOCATIONS: '/organization-settings/locations',
        DEFAULT_UNITS: '/organization-settings/default-units',
        ACCOUNT_REQUESTS: '/organization-settings/account-requests',
        CHIEF_COMPLAINTS: '/organization-settings/chief-complaints',
        ROLES: '/organization-settings/roles'
    },
    MANAGER_SETTINGS: {
        ROOT: '/manager-settings'
    },
    EMC_MERRGE_SETTINGS: {
        ROOT: '/emc-merrge-settings',
        SUPERADMIN_USER_MANAGEMENT: '/emc-merrge-settings/superadmin-user-management',
        SUPERADMIN_CREATE: '/emc-merrge-settings/superadmin-user-management/create-superadmin',
        SUPERADMIN_EDIT: '/emc-merrge-settings/superadmin-user-management/edit-superadmin/:id',
    },
    MERRGE211: {
      ROOT: '/merrge211',
      RESPONDER_CHECK_IN: '/merrge211/responder-check-in',
      APPROVED_RESPONDERS: '/merrge211/approved-responders',
      CHECKED_IN_DEPLOYABLE: '/merrge211/checked-in-deployable',
      MEAL_TRACKING: '/merrge211/meal-tracking',
      CHECK_IN_RESPONDER: '/merrge211/check-in',
      STATUS_REPORT: '/merrge211/status-report',
      CHANGE_STATUS: '/merrge211/change-status',
      TIME_AND_TRAVEL: '/merrge211/time-and-travel',
      TIME_AND_TRAVEL_DETAILS: '/merrge211/time-and-travel/details',
      INCIDENT_LOCATIONS: '/merrge211/incident-locations',
      EDIT_RESPONDER_TEAM_FORM: '/merrge211/edit/team',
      STATUS_MAP: '/merrge211/status-map'
    },
    // Error routes
    ERROR_404: '/404',
    ERROR_400: '/400',
    ERROR_500: '/500',
    ERROR_503: '/503',
    ERROR_401: '/401',
    SERVER_DOWN: '/server-down'
} as const;
